import axios from 'axios'
import { FormikProps } from 'formik'
import {useEffect, useState} from 'react'
import { useDispatch } from 'react-redux'
import { Select } from '../../Form'
import { DoctorSelectModel } from './models'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    prop: FormikProps<any>
}

export function SearchDoctor({prop}: Props) {

    const dispatch = useDispatch()
    const [selectItem, setSelectItem] = useState<DoctorSelectModel>()

    async function getSelectData() {
        try {
            const {data} = await axios.get<DoctorSelectModel>('/functions/get-doctors')
            setSelectItem(data)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        getSelectData()
    }, [dispatch])

    return (
        <div className='col-12 col-lg-6 mb-5'>
            <Select
                label='Profissional'
                name='doctor_id'
                formik={prop}
            >
                {selectItem?.data.select.map((item) => (
                    <option key={`op-${item.id}`} value={item.id}>
                        {item.nm_doctor}
                    </option>
                ))}
            </Select>
        </div>
    )
}
